<template>
  <v-row dense class="client-information-form-agent-row" align="start" justify="space-around">
    <v-col cols="auto" class="client-information-form-agent-row-button mt-3">
      <v-btn v-if="showAdd" elevation="0" @click="onAdd" class="d-block mx-auto" fab small>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-col>
    <v-col cols="auto" class="agents-row-text-field">
      <ValidationProvider name="agent" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Nombre"
          color="blue-grey"
          :value="row.name"
          @input="(newVal) => $emit('data:change', { field: 'name', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="agents-row-text-field">
      <ValidationProvider name="email" rules="required" v-slot="{ errors }">
        <v-text-field
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Email"
          color="blue-grey"
          :value="row.email"
          @input="(newVal) => $emit('data:change', { field: 'email', value: newVal })"
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="agents-row-text-field">
      <ValidationProvider name="rol" rules="required" v-slot="{ errors }">
        <v-select
          required
          filled
          rounded
          class="rounded-small"
          dense
          label="Rol"
          color="blue-grey"
          :value="row.role"
          @input="(newVal) => $emit('data:change', { field: 'role', value: newVal })"
          :error-messages="errors"
          :items="roleOptions"
          item-text="label"
          item-value="id"
        ></v-select>
      </ValidationProvider>
    </v-col>
    <v-col cols="auto" class="client-information-form-agent-row-button mt-3">
      <v-btn v-if="showDelete" class="d-block mx-auto" @click="onDelete(row.id)" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import { roleOptions } from "@/components/ClientInformation/utils";
export default {
  props: {
    showAdd: {
      type: Boolean,
      default: false,
    },
    showDelete: {
      type: Boolean,
      default: false,
    },
    onAdd: {
      type: Function,
    },
    onDelete: {
      type: Function,
    },
    row: {
      type: Object,
    },
  },

  data() {
    return {
      roleOptions,
    };
  },
};
</script>

<style>
.agents-row-text-field {
  width: 26.6666%;
  margin: 3px auto;
}

.client-information-form-agent-row-button {
  width: 10%;
}
</style>
